var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-date-picker-range',{staticClass:"d-flex justify-content-lg-end",attrs:{"labels":[_vm.$t('dashboard.period_filter')],"range":_vm.queryFormatted},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }